/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-len */
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import { updateProspect } from "../../../../store/actions/appConfig";
import {
  Input,
  AutoSaveField as Field,
  Checkbox,
  SelectAutocomplete
} from "../../../../components/Form";
import { MAX_PO_BOX_LENGTH } from "./constants";
import { Card } from "../../../../components/v2/Card/Card";
import { Title } from "./styled";

export const SignatoryPreferredMailingAddressComponent = ({
  index,
  organisationAddressLine2,
  organisationAddressLine1,
  organisationAddressLine3,
  organisationAddressLine4,
  organisationPoBox,
  organisationEmirateCity,
  organisationCountry,
  isShareholderACompany,
  isFieldsRequired = true,
  isComeFromROScreens,
  setValues,
  values,
  setFieldValue,
  setFieldTouched
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    setFieldValue("officeAddressLine1", organisationAddressLine1);
    setFieldValue("officeAddressLine2", organisationAddressLine2);
    setFieldValue("officePoBox", organisationPoBox);
    setFieldValue("officeEmirateCity", organisationEmirateCity);
    setFieldTouched("officeEmirateCity", false);
    setFieldValue("officeCountry", organisationCountry);
    setFieldTouched("officeCountry", false);
    dispatch(
      updateProspect({
        [`prospect.signatoryInfo[${index}].kycDetails.addressInfo[1].typeOfAddress`]: "Office Address",
        [`prospect.signatoryInfo[${index}].kycDetails.addressInfo[1].addressDetails.addressLine1`]: organisationAddressLine1,
        [`prospect.signatoryInfo[${index}].kycDetails.addressInfo[1].addressDetails.addressLine2`]: organisationAddressLine2,
        [`prospect.signatoryInfo[${index}].kycDetails.addressInfo[1].addressDetails.addressLine3`]: organisationAddressLine3,
        [`prospect.signatoryInfo[${index}].kycDetails.addressInfo[1].addressDetails.addressLine4`]: organisationAddressLine4
      })
    );
  }, []);

  const basePath = `prospect.signatoryInfo[${index}].kycDetails.addressInfo[1].addressDetails`;
  return (
    <Card title="Office address">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Title>Office address</Title>
        </Grid>
        <Grid item sm={6} xs={12}>
          <Field
            name="sameAsCompanyAddress"
            // classes={{ formControlRoot: classes.sameAsCompanyAddressCheckbox }}
            path={`prospect.signatoryInfo[${index}].kycDetails.sameAsCompanyAddress`}
            component={Checkbox}
            label="Same as personal address"
            onSelect={() => {
              setValues({
                sameAsCompanyAddress: true,
                officeAddressLine2: values.sameAsCompanyAddress ? organisationAddressLine2 : "",
                officeAddressLine1: values.sameAsCompanyAddress ? organisationAddressLine1 : "",
                officeEmirateCity: values.sameAsCompanyAddress ? organisationEmirateCity : "",
                officePoBox: values.sameAsCompanyAddress ? organisationPoBox : "",
                officeCountry: values.sameAsCompanyAddress ? organisationCountry : ""
              });
            }}
            checked={true}
            disabled
          />
        </Grid>
      </Grid>
      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item sm={6} xs={12}>
          <Field
            name="officeEmirateCity"
            path={`${basePath}.emirateCity`}
            //disabled={values.sameAsCompanyAddress}
            disabled
            datalistId="emirateCity"
            label={`Emirate/ City${
              isShareholderACompany || !isFieldsRequired ? " (optional)" : " *"
            }`}
            isSearchable
            component={SelectAutocomplete}
            tabIndex="0"
            placeholder="Start typing here ..."
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Field
            name="officePoBox"
            path={`${basePath}.poBox`}
            //disabled={values.sameAsCompanyAddress}
            disabled
            label={`PO Box Number${
              isShareholderACompany || !isFieldsRequired ? " (optional)" : " *"
            }`}
            placeholder="AB1234"
            component={Input}
            InputProps={{
              inputProps: { maxLength: MAX_PO_BOX_LENGTH, tabIndex: 0 }
            }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Field
            name="officeCountry"
            path={`${basePath}.country`}
            label="Country"
            placeholder="Country"
            disabled
            component={SelectAutocomplete}
            datalistId="country"
            InputProps={{
              inputProps: { tabIndex: 0 }
            }}
          />
        </Grid>
      </Grid>
      {isComeFromROScreens && (
        <Grid container spacing={3} sx={{ mt: 1 }}>
          <Grid item xs={12}>
            <Field
              name="residenceType"
              path={`${basePath}.residenceType`}
              datalistId="residenceType"
              label="Residence Type"
              component={SelectAutocomplete}
            />
          </Grid>
        </Grid>
      )}
    </Card>
  );
};

// PropTypes validation
SignatoryPreferredMailingAddressComponent.propTypes = {
  /** Index of the signatory in the array */
  index: PropTypes.number.isRequired,
  /** Organisation address line 1 */
  organisationAddressLine1: PropTypes.string,
  /** Organisation address line 2 */
  organisationAddressLine2: PropTypes.string,
  /** Organisation address line 3 */
  organisationAddressLine3: PropTypes.string,
  /** Organisation address line 4 */
  organisationAddressLine4: PropTypes.string,
  /** Organisation PO Box number */
  organisationPoBox: PropTypes.string,
  /** Organisation emirate/city */
  organisationEmirateCity: PropTypes.string,
  /** Organisation country */
  organisationCountry: PropTypes.string,
  /** Flag indicating if shareholder is a company */
  isShareholderACompany: PropTypes.bool,
  /** Flag indicating if fields are required */
  isFieldsRequired: PropTypes.bool,
  /** Flag indicating if component is from RO screens */
  isComeFromROScreens: PropTypes.bool,
  /** Function to set form values */
  setValues: PropTypes.func.isRequired,
  /** Current form values */
  values: PropTypes.shape({
    /** Flag indicating if address is same as company address */
    sameAsCompanyAddress: PropTypes.bool,
    /** Address line 1 */
    officeAddressLine1: PropTypes.string,
    /** Address line 2 */
    officeAddressLine2: PropTypes.string,
    /** Emirate/City */
    officeEmirateCity: PropTypes.string,
    /** PO Box number */
    officePoBox: PropTypes.string,
    /** Country */
    officeCountry: PropTypes.string
  }).isRequired,
  /** Function to set a specific field value */
  setFieldValue: PropTypes.func.isRequired,
  /** Function to set a field as touched */
  setFieldTouched: PropTypes.func.isRequired
};
